const API_BASE = process.env.NODE_ENV === "production"
  ? `${window.location.protocol}//${window.location.host}`
  : `https://${window.location.hostname}:8000`;

export async function initializeApiBase() {
  // No-op
}

export const resolveDrawingUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('data:') || url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `${API_BASE}${url}`;
};

export default API_BASE;
